import apiRequests from './api';
import apiRoutes from './apiRoutes';

const CACHE_KEYS = {
  CHECKLISTS: '@ls-client/checklists',
  REQUEST_FORMS: '@ls-client/request-forms',
};

// TTL - 7 days
// const DEFAULT_TTL = 7 * 24 * 60 * 60 * 1000;
const DEFAULT_TTL = 0;

function isExpired(item: any) {
  if (!item || !item.timestamp) return true;
  return Date.now() - item.timestamp > DEFAULT_TTL;
}

function getCache(key: string) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (isExpired(parsed)) {
      localStorage.removeItem(key);
      return null;
    }

    return parsed.data;
  } catch {
    return null;
  }
}

function setCache(key: string, data: any) {
  localStorage.setItem(
    key,
    JSON.stringify({
      data,
      timestamp: Date.now(),
    })
  );
}

// -------- MAIN FUNCTIONS -------- //

export async function getChecklists() {
  const cached = getCache(CACHE_KEYS.CHECKLISTS);
  if (cached) return cached;

  const response = await apiRequests.get(apiRoutes.CHECKLISTS);
  setCache(CACHE_KEYS.CHECKLISTS, response.data);
  return response.data;
}

export async function getRequestForms() {
  const cached = getCache(CACHE_KEYS.REQUEST_FORMS);
  if (cached) return cached;

  const response = await apiRequests.get(apiRoutes.REQUESTS);
  setCache(CACHE_KEYS.REQUEST_FORMS, response.data);
  return response.data;
}

export function clearApiCache() {
  Object.values(CACHE_KEYS).forEach((key) => localStorage.removeItem(key));
}
